<!--Envío de muestras-->
<div *ngIf="enviandoMuestras || hayEnvioMuestrasInspector" [formGroup]="form" class="row">

    <!-- Motivos -->
    <div class="col-md-4">
        <div class="card card-accent-success animated fadeIn">
            <div class="card-header-buscador">
                <i class="fa fa-plus"></i> <strong id="stMotivo">Motivos</strong>
                <label class="col-form-label required-field" for="stMotivo"></label>
            </div>
            <div class="card-body-detalle-list">

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="input-group">
                                <ng-select class="ngselect-listbox"
                                           [(items)]="listMotivos"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdMotivo"
                                           loadingText="Cargando..."
                                           [loading]="!listMotivos"
                                           notFoundText="Motivo no encontrado"
                                           placeholder="-- Seleccione un Motivo --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdMotivo')">
                                </ng-select>
                                <span class="input-group-btn">
                                    &nbsp;<button [disabled]="hayEnvioMuestrasInspector" name="btnAddMotivo" class="btn btn-list btn-secondary btn-listbox"
                                                  type="button" title="Añade un Motivo" (click)="onAddMotivo()">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <label class="cabeceraTablaDetalles">Motivos</label>
                        <table class="table table-list table-sm">
                            <tbody>
                                <tr *ngFor="let item of motivosMuestraLaboratorio">
                                    <td scope="col">
                                        <div class="btn-group">
                                            <button *ngIf="!hayEnvioMuestrasInspector" (click)="onDeleteMotivo(item)" type="button" title="Eliminar motivo"
                                                    class="btn btn-sm btn-danger btn-listbox">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td scope="col" class="td-list">{{item.DescripcionMotivo}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdMotivo','required')">
                            * Debe especificar al menos un motivo.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Productos -->
    <div class="col-md-4">
        <div class="card card-accent-success animated fadeIn">
            <div class="card-header-buscador">
                <i class="fa fa-plus"></i> <strong id="stProducto">Productos</strong>
                <label class="col-form-label required-field" for="stProducto"></label>
            </div>
            <div class="card-body-detalle-list">

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="input-group">
                                <ng-select class="ngselect-listbox"
                                           [(items)]="listProductos"
                                           bindLabel="IdTaricProductoNombreCientificoNombreComun"
                                           bindValue="Id"
                                           formControlName="IdProducto"
                                           loadingText="Cargando..."
                                           [loading]="!listProductos"
                                           notFoundText="Producto no encontrado"
                                           placeholder="-- Seleccione un Producto --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdProducto')">
                                </ng-select>
                                <span class="input-group-btn">
                                    &nbsp;<button [disabled]="hayEnvioMuestrasInspector" name="btnAddProducto" class="btn btn-list btn-secondary btn-listbox"
                                                  type="button" title="Añade un Producto" (click)="onAddProducto()">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <label class="cabeceraTablaDetalles">Productos</label>
                        <table class="table table-list table-sm">
                            <tbody>
                                <tr *ngFor="let item of productosMuestraLaboratorio">
                                    <td scope="col">
                                        <div class="btn-group">
                                            <button *ngIf="!hayEnvioMuestrasInspector" (click)="onDeleteProducto(item)" type="button" title="Eliminar producto"
                                                    class="btn btn-sm btn-danger btn-listbox">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td scope="col" class="td-list">{{item.IdTaricProductoNombreCientificoNombreComun}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdProducto','required')">
                            * Debe seleccionar al menos un producto o un embalaje.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <!-- Embalajes -->
    <div class="col-md-4">
        <div class="card card-accent-success animated fadeIn">
            <div class="card-header-buscador">
                <i class="fa fa-plus"></i> <strong id="stEmbalaje">Embalajes</strong>
                <label class="col-form-label required-field" for="stEmbalaje"></label>
            </div>
            <div class="card-body-detalle-list">

                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <div class="input-group">
                                <ng-select class="ngselect-listbox"
                                           [(items)]="listEmbalajes"
                                           bindLabel="IdTaricEmbalajeDescripcion"
                                           bindValue="Id"
                                           formControlName="IdEmbalaje"
                                           loadingText="Cargando..."
                                           [loading]="!listEmbalajes"
                                           notFoundText="Embalaje no encontrado"
                                           placeholder="-- Seleccione un Embalaje --"
                                           clearAllText="Eliminar selección"
                                           [ngClass]="displayFieldCssNgSelect('IdEmbalaje')">
                                </ng-select>
                                <span class="input-group-btn">
                                    &nbsp;<button [disabled]="hayEnvioMuestrasInspector" name="btnAddEmbalaje" class="btn btn-list btn-secondary btn-listbox"
                                                  type="button" title="Añade un Embalaje" (click)="onAddEmbalaje()">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <label class="cabeceraTablaDetalles">Embalajes</label>
                        <table class="table table-list table-sm">
                            <tbody>
                                <tr *ngFor="let item of embalajesMuestraLaboratorio">
                                    <td scope="col">
                                        <div class="btn-group">
                                            <button [disabled]="hayEnvioMuestrasInspector" (click)="onDeleteEmbalaje(item)" type="button" title="Eliminar embalaje"
                                                    class="btn btn-sm btn-danger btn-listbox">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                    <td scope="col" class="td-list">{{item.IdTaricEmbalajeDescripcion}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdEmbalaje','required')">
                            * Debe seleccionar al menos un producto o un embalaje.
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
